/* eslint-disable react/jsx-no-bind */
import React from "react";

import * as styles from "./PricesFrom.module.scss";
import { EnhancedCruisePriceFrom } from "src/ssc-api/prices/types";
import { useLingui } from "@lingui/react/macro";
import {
  perGuestLabel,
  transformPriceFrom,
  withLowestFareAvailableLabel
} from "components/Prices/utils";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import {
  PriceBox,
  PriceBoxBottomLabel,
  PriceBoxTopLabel
} from "@silversea-ssc/ui-components-react";
import { useStaticFareLabels } from "features/fare/use-static-fare-labels";

type PricesFromProps = EnhancedCruisePriceFrom;

export const PricesFrom: React.FC<React.PropsWithChildren<PricesFromProps>> = ({
  priceFrom,
  children
}) => {
  const geolocation = useGeolocation();
  const { fareCodeLabel } = useStaticFareLabels();
  const { t } = useLingui();
  const isWaitlist = priceFrom?.type == "waitlist";
  const transformedPrice = transformPriceFrom(
    t,
    priceFrom,
    geolocation.defaultCurrency,
    true,
    "only-from",
    fareCodeLabel
  );

  const showChildren =
    React.Children.toArray(children).filter(
      (child) => React.isValidElement(child) && child
    ).length > 0;

  return (
    <div>
      <div className={styles.singlePrice}>
        {transformedPrice && (
          <PriceBox
            price={transformedPrice}
            chipBackgroundColor="neutral05"
            topLabel={
              <PriceBoxTopLabel uppercase>
                {t({ id: "from-price" })}
              </PriceBoxTopLabel>
            }
            bottomLabel={
              isWaitlist ? undefined : (
                <PriceBoxBottomLabel uppercase>
                  <div>{t(withLowestFareAvailableLabel())}</div>
                </PriceBoxBottomLabel>
              )
            }
            rightLabel={
              <PriceBoxBottomLabel uppercase>
                {t(perGuestLabel())}
              </PriceBoxBottomLabel>
            }
          />
        )}
      </div>

      {showChildren && <div className={styles.disclaimer}>{children}</div>}
    </div>
  );
};
